module.exports = __webpack_public_path__ + "img/petstairs02.3773c6c5.jpg";